import "./list.scss"
import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import BillingDetails from "../../components/patient-timeline/billing"
const BillingDetailsContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <BillingDetails />
      </div>
    </div>
  )
}

export default BillingDetailsContainer